import React, {useCallback} from "react";
import {Input, Spin, Tree} from "antd";
import _ from "lodash";
import AutoSizer from "../autosizer";
import Empty from "../empty/Empty";

const nop = () => {};

const UserTree = ({
    treeData,
    getCheckedKeysFromItem,
    getCheckedNodesFromNode,
    style,
    value,
    loading,
    defaultExpandedKeys,
    onChange = nop,
    onSearch = nop,
}) => {
    const handleSearch = useCallback((searchValue) => {
        onSearch(searchValue);
    }, [onSearch]);

    const handleTreeChecked = useCallback((c, checkInfo) => {
        const {node, checked} = checkInfo;
        const nodes = getCheckedNodesFromNode(node);

        let newSelectedItems;
        if (checked) {
            newSelectedItems = _.chain(value ?? [])
                .concat(_.map(nodes, it => it.item))
                .uniqBy(it => it.id)
                .value();
        } else {
            const nodesMap = _.keyBy(nodes, it => it.item.id);
            newSelectedItems = _.filter(
                value,
                it => nodesMap[it.id] == null,
            );
        }
        onChange(newSelectedItems);
    }, [getCheckedNodesFromNode, value]);


    return (
        <Spin
            prefixCls="numas-spin"
            spinning={loading}
        >
            <div
                style={{
                    display: "flex",
                    flexFlow: "column nowrap",
                    height: 430,
                    ...style,
                }}
            >
                <Input.Search
                    onSearch={handleSearch}
                    style={{
                        flex: "none",
                        width: "auto",
                        margin: "12px 16px 0 16px",
                    }}
                />
                <div
                    style={{
                        flex: 1,
                        overflow: "auto",
                        marginTop: 12,
                    }}
                >
                    {_.isEmpty(treeData) && !loading
                        ? (
                            <Empty
                                text="科室内无可选成员"
                                footer={nop}
                            />
                        )
                        : (
                            <AutoSizer>
                                {
                            ({height, width}) => {
                                return (
                                    <Tree
                                        defaultExpandedKeys={defaultExpandedKeys}
                                        treeData={treeData}
                                        selectable={false}
                                        style={{height, width}}
                                        height={height}
                                        showIcon
                                        blockNode
                                        checkable
                                        checkedKeys={_.chain(value)
                                            .flatMap(getCheckedKeysFromItem)
                                            .compact()
                                            .value()}
                                        onCheck={handleTreeChecked}
                                    />
                                );
                            }
                        }
                            </AutoSizer>
                        )
                    
                    }

                </div>
            </div>
        </Spin>
    );
};

export default UserTree;
